import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    root: {
      width: 335,
      borderRadius: 6
    },
    dialogTitle: {
      padding: "10px 12px 10px 16px",
      borderBottom: `1px solid ${primary.light}`,
      display: "flex",
      justifyContent: "space-between",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      alignItems: "center",
      fontSize: 16
    },
    xButton: {
      padding: 0
    },
    dialogContent: {
      height: 494,
      padding: 0,
      overflowY: "hidden"
    },
    horseName: {
      minHeight: 50,
      fontSize: 16,
      padding: 16,
      textTransform: "capitalize",
      borderBottom: "1px solid #eee",
      wordBreak: "break-word"
    },
    horseDetails: {
      height: 444,
      overflowY: "auto"
    },
    row: {
      display: "flex",
      alignItems: "center",
      fontSize: 12,
      minHeight: 32,
      padding: "7px 0",
      borderTop: "1px solid #eee",
      "&:nth-child(even)": {
        backgroundColor: "#f7f7f7"
      },
      "&:first-child": {
        borderTop: "none"
      }
    },
    cell: {
      width: "50%",
      wordBreak: "break-word",
      "&:first-child": {
        paddingLeft: 16
      },
      "&.multiple": {
        flexDirection: "column",
        alignSelf: "flex-start"
      }
    },
    dialogActions: {
      padding: "8px 14px 12px"
    },
    multipleValue: {
      wordBreak: "break-all"
    }
  };
});
